module.exports = __webpack_public_path__ + "static/media/notebookWrong.d44a6dff.png";